import type { MediaImage as MediaImageType, Scalars, Video as VideoType } from "@shopify/hydrogen-react/storefront-api-types";
import React, { useEffect, useState } from "react";
import type { Swiper as SwiperCore } from "swiper";
import "swiper/css";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import Button from "@atoms/Button";
import Image from "@atoms/Image";
import Video from "@atoms/Video";

export interface IRestrictedMediaEdge {
  __typename?: "MediaEdge";
  cursor: Scalars["String"]["output"];
  node: VideoType | MediaImageType; // Video와 MediaImage만 허용
}

interface IProps {
  media: IRestrictedMediaEdge[];
  onEnlarge: (index: number) => void;
}

export default function MediaSlider({ media, onEnlarge }: IProps) {
  const [swiper, setSwiper] = useState<SwiperCore | null>(null);

  useEffect(() => {
    swiper?.slideTo(0);
  }, [media]);

  return (
    <Swiper
      autoHeight
      className="pc:w-full pc:translate-x-0 mb-2.5 aspect-1280/1707 h-auto w-screen -translate-x-4"
      freeMode={false}
      loop={media.length > 1}
      modules={[Pagination]}
      navigation
      onSwiper={(swiperElement) => {
        setSwiper(swiperElement);
      }}
      pagination={{
        type: "custom",
        renderCustom: (swiperCore, current, total) => {
          return `${Number.isNaN(current) ? 1 : current} of ${total}`;
        },
      }}
      slidesPerView={1}
      wrapperClass="h-full!"
      wrapperTag="ul"
    >
      {media.map(({ node }, index) => (
        <SwiperSlide className="h-full!" key={node.id} tag="li">
          <Button
            as="wrapper"
            className="flex h-full! w-full justify-center bg-white"
            onClick={() => {
              onEnlarge(index);
            }}
          >
            {(() => {
              const isImageNode = node.mediaContentType === "IMAGE";
              if (isImageNode) {
                const castedNode = node as MediaImageType;
                return (
                  <Image
                    alt={castedNode.image?.altText || ""}
                    height={castedNode.image?.height || 1707}
                    src={castedNode.image?.url || ""}
                    width={castedNode.image?.width || 1280}
                  />
                );
              }
              const castedNode = node as VideoType;
              const firstSource = castedNode.sources[1];
              return (
                <Video
                  className="object-cover"
                  height={castedNode.previewImage?.height || 1707}
                  poster={castedNode.previewImage?.url || ""}
                  src={firstSource.url}
                  width={castedNode.previewImage?.width || 1280}
                />
              );
            })()}
          </Button>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
